import templateUrl from 'emun.salesrep/salesrep-customer-retention.htm';
import basicController from "servicestack/basic.controller.properties";
import ServiceBus from 'servicestack/service-bus';
import AutoQuery from 'servicestack/auto-query/auto-query'

class SalesRepCustomerRetentionController {
	constructor($window, $rootScope, retailerPrompt, createAutoQuery, utils) {
		let $ctrl = this; 

		basicController($ctrl);
		var context = $ctrl.context || 'rep';
		$ctrl.utils = utils;
		$ctrl.bus = new ServiceBus();
		$ctrl.repFilter = "";
		if (context !== 'executive') {
			var filterType = "SalesRepID";
			if (context === 'manager') {
				filterType = 'ManagerId';
			}
			$ctrl.repFilter = "&" + filterType + "=" + $ctrl.rep.id;
		}		

	  
		$ctrl.customerRetention = new AutoQuery({
			//url: 'QueryOrderTotals.json?dateRange=YTD&grouping=strCustomerID&groupingLabel=strCompanyName&' + filter + '=' + $ctrl.rep.id,
			url: $ctrl.insideSales === 'true' ? 'QuerySalesRepCustomerRetentionInsideSales.json?' : 'QuerySalesRepCustomerRetention.json?' + $ctrl.repFilter,
			autoLoad: true,
			pageSize: 10000
		});
	}

	downloadDataDetail() {
		let $ctrl = this;
		var itemsFormatted = [];

		var headers = {
			SalesRepName: 'Sales Rep',
			CustomerId: 'Customer ID',
			CustomerName: 'Customer Name',
			ShipId: 'Ship ID',
			ShipName: 'Ship Name',
			ShipAddress1: 'Ship Address 1',
			ShipAddress2: 'Ship Address 2',
			ShipCity: 'Ship City',
			ShipState: 'Ship State',
			ShipZip: 'Ship Zipcode',
			TYCount: 'Count of # Orders TY',
			LYCount: 'Count of # Orders LY',
			RetentionCountPercentage: 'Retention % of Count',
			TYSales: '$ Total of Orders TY',
			LYSales: '$ Total of Orders LY',
			RetentionSalesPercentage: 'Retention % of $'
		};

		$ctrl.customerRetentionDetail = new AutoQuery({
			url: $ctrl.insideSales === 'true' ? 'QuerySalesRepCustomerRetentionInsideSalesDetail.json?' : 'QuerySalesRepCustomerRetentionDetail.json?' + $ctrl.repFilter,
			autoLoad: true,
			orderBy: "CustomerName,ShipName",
			pageSize: 10000,
			onLoaded: function (res) {
				res.results.forEach((item) => {
					itemsFormatted.push({
						SalesRepName: item.salesRepName,
						CustomerId: item.customerId,
						CustomerName: item.customerName.replace(/,/g, ''), // remove commas to avoid errors,
						ShipId: item.shipId,
						ShipName: item.shipName,
						ShipAddress1: item.shipAddress1 || "",
						ShipAddress2: item.shipAddress2 || "",
						ShipCity: item.shipCity,
						ShipState: item.shipState,
						ShipZip: item.shipZip,
						TYCount: item.tyCount,
						LYCount: item.lyCount,
						RetentionCountPercentage: item.retentionCountPercentage + "%",
						TYSales: "$" + item.tySales.toFixed(0),
						LYSales: "$" + item.lySales.toFixed(0),
						RetentionSalesPercentage: item.retentionSalesPercentage + "%"
					});
				});
				var fileTitle = 'Customer Retention Report';
				$ctrl.utils.exportCSVFile(headers, itemsFormatted, fileTitle);
			}
		});

	}

	downloadData() {
		let $ctrl = this;
		var itemsFormatted = [];

		var headers = {
			ID: 'SalesRepId',
			Name: "SalesRepName",
			YT: "TYCount",
			LY: "LYCount",
			RetentionPercent: "RetentionPercentage"
		};

		// format the data
		$ctrl.customerRetention.results.forEach((item) => {
			itemsFormatted.push({
				ID: item.salesRepID,
				name: item.salesRepName.replace(/,/g, ''), // remove commas to avoid errors,
				YT: "$" + item.tyCount.toFixed(0),
				LY: "$" + item.lyCount.toFixed(0),
				RetentionPercent: item.retentionPercentage + "%"
			});
		});

		var fileTitle = 'customer-retention';
		$ctrl.utils.exportCSVFile(headers, itemsFormatted, fileTitle);
	}
}

let SalesRepCustomerRetention = {
	bindings: {
		rep: '<',
		context: '@',
		insideSales: '@',
	},
	controller: SalesRepCustomerRetentionController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};


export default SalesRepCustomerRetention;